<template>
  <div class="home__gallery">
    <h1 class="home__gallery__heading">Galeria naszych potraw</h1>
    <div class="home__gallery__wrapper">
      <div class="image"
           v-for="image in gallery_images"
           :style="{'background': 'url(' + image + ') center / cover'}"></div>
    </div>
  </div>
</template>

<script>
import images from '../../static_data/images'

export default {
  name: 'Gallery',
  data () {
    return {
      gallery_images: []
    }
  },
  created () {
    this.get5RandomImages();
  },
  methods: {
    get5RandomImages () {
      let randomImages = [];

      while (randomImages.length < 5) {
        let randomIndex = Math.floor(Math.random() * images.length);

        if (!randomImages.includes(images[randomIndex])) {
          randomImages.push(images[randomIndex])
        }
      }

      this.gallery_images = randomImages
    }
  }
}
</script>
